<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmtitle"><a id="h3">List of Maps</a></h2><a id="h3">
</a><p class="num"><a id="h3"></a><a href="#/06_front01#map01"><span class="no">1.</span> British sectors of the Western Front</a></p>
<p class="num"><a href="#/11_part01a#map02"><span class="no">2.</span> Into the Salient</a></p>
<p class="num"><span href="#/20_part02a#map03" title="Link target outside of Sample"><span class="no">3.</span> Attack by D Battalion on 22 August 1917</span></p>
<p class="num"><span href="#/33_chapter19#map04" title="Link target outside of Sample"><span class="no">4.</span> Actions by D Battalion in the Ypres Salient 1917</span></p>
<p class="num"><span href="#/36_part04a#map05" title="Link target outside of Sample"><span class="no">5.</span> Into Hiding</span></p>
<p class="num"><span href="#/40_chapter24#map06" title="Link target outside of Sample"><span class="no">6.</span> The start of the attack on Flesquières, 20 November 1917</span></p>
<p class="alpha"><span href="#/40_chapter24#map06a" title="Link target outside of Sample"><span class="alp">(a)</span> Relief map with height in metres</span></p>
<p class="alpha"><span href="#/40_chapter24#map06b" title="Link target outside of Sample"><span class="alp">(b)</span> German units, showing sector held by 84th Infantry Regiment</span></p>
<p class="alpha"><span href="#/40_chapter24#map06c" title="Link target outside of Sample"><span class="alp">(c)</span> Artillery barrage</span></p>
<p class="alpha"><span href="#/40_chapter24#map06d" title="Link target outside of Sample"><span class="alp">(d)</span> Overview of attack on the Hindenburg Line at Cambrai</span></p>
<p class="num"><span href="#/48_chapter31#map07" title="Link target outside of Sample"><span class="no">7.</span> Flesquières on the evening of 20 November 1917</span></p>
<p class="alpha"><span href="#/48_chapter31#map07a" title="Link target outside of Sample"><span class="alp">(a)</span> Situation on the evening of 20 November 1917</span></p>
<p class="num"><span href="#/50_chapter33#map08" title="Link target outside of Sample"><span class="no">8.</span> Situation at the end of the Battle of Cambrai</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_maps.vue?5210abe0